import { toBrokerOption } from '@/bundles/Dashboards/mappers';
import {
  IDealsDashboardFilterOptions,
  IDealsDashboardFilterOptionsGetOne,
} from '@/bundles/Deals/types';

export function mapDealsFilterOptions (
  response: IDealsDashboardFilterOptionsGetOne,
): IDealsDashboardFilterOptions {
  return {
    broker: (response.agents ?? []).map(toBrokerOption),
  };
}
